import { z } from 'zod';
import { FreightOrigin } from '../../../../../../conditions/orderCondition.types';

export const MIN_DELIVERY_TERM_BUSINESS_DAYS = 0;

interface BuildOrderConditionDetailsSchemaParams {
  deliveryTermInvalidMessage: string;
}

export const buildOrderConditionDetailsSchema = ({
  deliveryTermInvalidMessage,
}: BuildOrderConditionDetailsSchemaParams) =>
  z.object({
    paymentId: z.string().nullable(),
    commercialPolicyId: z.string().nullable(),
    voucherId: z.string().nullable(),
    deliveryAddressId: z.string().nullable(),
    shippingCostValue: z.number().nullable(),
    billingForecastDate: z.date().nullable(),
    shippingCompanyId: z.string().nullable(),
    shippingCompanyName: z.string().nullable(),
    shippingCompanyExternalId: z.string().nullable(),
    shippingMethod: z.string().nullable(),
    estimatedShippingBusinessDays: z
      .number({ error: deliveryTermInvalidMessage })
      .int()
      .min(MIN_DELIVERY_TERM_BUSINESS_DAYS)
      .nullable(),
    estimatedShippingDate: z.date().nullable(),
    quoteId: z.string().nullable(),
    freightOrigin: z.nativeEnum(FreightOrigin).nullable(),
    internalObservation: z.string().nullable(),
    observation: z.string().nullable(),
  });

export type OrderConditionDetailsFormValues = z.infer<
  ReturnType<typeof buildOrderConditionDetailsSchema>
>;
